export const bitrixAppPath = "/bitrix/app";

export default {
  path: bitrixAppPath,
  name: "bitrix-app",
  meta: {
    layout: "empty",
    requiresAuth: false,
  },
  component: () => import("@/views/Bitrix/BitrixApp"),
};
